import { render, staticRenderFns } from "./GeneralConfig.vue?vue&type=template&id=1b79aa5e&scoped=true&"
import script from "./GeneralConfig.vue?vue&type=script&lang=js&"
export * from "./GeneralConfig.vue?vue&type=script&lang=js&"
import style0 from "./GeneralConfig.vue?vue&type=style&index=0&id=1b79aa5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b79aa5e",
  null
  
)

export default component.exports